import { render, staticRenderFns } from "./ViewTemplatesFunction.vue?vue&type=template&id=1b9bd16e&"
import script from "./ViewTemplatesFunction.vue?vue&type=script&lang=js&"
export * from "./ViewTemplatesFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports